import React, { Component } from "react"
import { NavLink } from "react-router-dom"

class MainMenu extends Component {
  render() {

    const { dataPrimary } = this.props;

    return (
      <nav className="flex justify-end">
        <ul className="m-0 items-center">
          {dataPrimary && dataPrimary.items && dataPrimary.items.map(prop => {
            return (
              <NavLink key={prop.id} to={'/'+prop.object_slug} alt={prop.title} activeClassName="underlined xs:font-semibold" className="nav-item font-semibold mx-4 last:bg-orange last:btn last:mx-2 last:font-semibold last:text-white last:py-3 last:px-6 last:rounded-md last:ml-4 last:mr-0">
                {prop.title}
              </NavLink>
            )
          })}
        </ul>
      </nav>
    )
  }
}

export default MainMenu
